var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40.7695 27.538V19.8096L80.9709 12.0457L81.5388 22.368",
  fill: "#D1C8B9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.7687 27.538V19.8096L0.460938 12.0457V22.368",
  fill: "#E5DFD7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.2302 62.8047L40.7687 86.594L0.460938 67.9747L41.2302 62.8047Z",
  fill: "#E5DFD7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.2305 76.0052L81.9997 67.9747L41.2305 62.8047V76.0052Z",
  fill: "#D1C8B9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.8449 17.1091L40.77 19.8096L15.7617 15.7766L26.4998 12.0457L54.8449 17.1091Z",
  fill: "#BDB09B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.5645 0V14.3376L46.1476 17.1091L81.3969 22.368L80.8999 12.0634L27.5645 0Z",
  fill: "#E5DFD7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.5641 0L0.248485 12.0634L0 22.368L18.0329 17.1091L27.5641 14.3376V0Z",
  fill: "#F2EFEB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.3816 61.6142L28.2032 51.7361H20.8552L19.2578 54.6853C18.1396 56.7818 16.5777 59.731 15.7612 61.7564C15.8322 59.6955 15.8855 57.4036 15.8855 54.9163V51.7361H9.31836V78.9543H15.8855V69.8934L17.5184 67.5305L21.4409 78.9543H28.7002L22.3816 61.6142Z",
  fill: "#595478"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.6445 65.3806C40.6445 71.9542 39.6328 73.7841 37.6094 73.7841C35.586 73.7841 34.5388 71.8831 34.5388 65.3095C34.5388 58.7359 35.515 56.906 37.5739 56.906C39.5973 56.906 40.6445 58.807 40.6445 65.3806ZM47.318 65.2918C47.318 55.7334 43.6973 51.2917 37.6094 51.2917C31.5038 51.2917 27.8652 55.7689 27.8652 65.3628C27.8652 74.9567 31.4328 79.3628 37.5384 79.3628C43.6795 79.3806 47.318 74.9034 47.318 65.2918Z",
  fill: "#595478"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.0318 53.6548H47.5137V59.3223H53.0336V80.8731H59.5119V59.3223H65.0318V53.6548Z",
  fill: "#595478"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.9245 51.7358H67.3574V78.9541H73.9245V51.7358Z",
  fill: "#595478"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.04819 98.9061L27.8668 119V76.0051L0.302734 67.9746L1.04819 98.9061Z",
  fill: "#F2EFEB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.8652 76.0051V119L80.544 98.9061L81.9994 67.9746L27.8652 76.0051Z",
  fill: "#E5DFD7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.8244 45.5709C21.1028 45.5709 20.1976 43.9364 20.1976 38.3222C20.1976 32.708 21.0318 31.1268 22.7889 31.1268C24.5106 31.1268 25.4158 32.7613 25.4158 38.3755C25.4158 44.0075 24.5461 45.5709 22.8244 45.5709ZM22.8244 26.3298C17.6062 26.3298 14.4824 30.1496 14.4824 38.3755C14.4824 46.6014 17.5352 50.3501 22.7534 50.3501C28.0071 50.3501 31.1309 46.5303 31.1309 38.3045C31.1309 30.1319 28.0426 26.3298 22.8244 26.3298Z",
  fill: "#595478"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.4532 22.1548L43.3593 22.5989L41.7973 28.5685C40.9986 31.571 40.3597 34.3781 40.1645 36.066C39.7207 34.4314 38.5493 31.7132 37.3069 28.9949L34.6978 23.3629L29.5684 23.8071L31.645 47.4721L36.7744 47.0279L36.3129 41.7868C36.1 39.2462 35.816 36.8832 35.5852 34.9289C36.2597 36.7411 37.4666 39.637 38.4251 41.6624L41.1761 47.3832L42.88 41.2715C43.5012 39.104 44.158 36.0482 44.4952 34.1472C44.5662 36.1903 44.7437 38.4822 44.9567 41.0228L45.4181 46.2639L50.5121 45.8198L48.4532 22.1548Z",
  fill: "#595478"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.6881 25.3171H53.8309L47.6543 49.2131H53.5114L54.3634 44.7715H59.0668L59.9543 49.2131H65.8114L59.6881 25.3171ZM55.3041 40.1344L55.4461 39.3882C56.0318 36.208 56.511 33.6141 56.7062 31.4288C56.937 33.6141 57.4517 36.208 58.0019 39.3527L58.1439 40.1344H55.3041Z",
  fill: "#595478"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 82,
  height: 119,
  fill: "white"
})));

function SvgOmaKotiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 119,
    viewBox: "0 0 82 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmaKotiLogo);
export default __webpack_public_path__ + "static/media/omaKotiLogo.ce877845f696bde14b20247c3da80027.svg";
export { ForwardRef as ReactComponent };